module.exports = __webpack_public_path__ + "static/Darran-d3a6d1e2594cc4aaaf89867c3be05d15.jpg";